import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=63a329f2&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"
import style0 from "./Token.vue?vue&type=style&index=0&id=63a329f2&prod&lang=css&"
import style1 from "./Token.vue?vue&type=style&index=1&id=63a329f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a329f2",
  null
  
)

export default component.exports